"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const react_1 = require("react");
const globalCodeMirrorStyles_1 = __importDefault(require("./globalCodeMirrorStyles"));
const useCodeMirror_1 = __importDefault(require("./useCodeMirror"));
const codemirror_1 = __importDefault(require("../../../styles/codemirror"));
const codemirror_overrides_1 = __importDefault(require("../../../styles/codemirror-overrides"));
const EditablePrettyText = ({ choiceGroups, initialValue, isErrored, isMultiline, onChange, onClickTag, onEscape, placeholder, }, ref) => {
    const textBoxRef = react_1.useRef(null);
    useCodeMirror_1.default({
        choiceGroups,
        initialValue,
        onChange,
        onClickTag,
        onEscape,
        placeholder,
        ref,
        textBoxRef,
    });
    const classNames = [
        'FieldsFormCodeMirror',
        {
            'FieldsFormCodeMirror--errored': isErrored,
            'FieldsFormCodeMirror--multiline': isMultiline,
        },
    ];
    return (common_utils_1.isolateComponent(react_1.Fragment, null,
        common_utils_1.isolateComponent(core_1.Global, { styles: codemirror_1.default }),
        common_utils_1.isolateComponent(core_1.Global, { styles: codemirror_overrides_1.default }),
        common_utils_1.isolateComponent(core_1.Global, { styles: globalCodeMirrorStyles_1.default }),
        common_utils_1.isolateComponent(core_1.ClassNames, null, ({ cx }) => (common_utils_1.isolateComponent("div", { className: cx(classNames), ref: textBoxRef })))));
};
exports.default = react_1.forwardRef(EditablePrettyText);
